import { Link } from "react-router-dom";
import React from "react";
const ErvaringenMenu = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("ervaringen")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" || token.role === "ervaringeigenaar") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon"><i className="fa fa-solid fa-torii-gate"></i></span>
            <span className="menu-text">Beheer Ervaringen</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}><i className="fas fa-chevron-right"></i></span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/ervaringen" className="menu-link">
                <span className="menu-icon"><i className="fa fa-warehouse"></i></span>
                <span className="menu-text">Ervaringen</span>
              </Link>
            </div>
            {token.role === "admin" ||
              token.role === "manager" ||
              token.role === "medewerker" && (
                <div className="menu-item">
                  <Link to="/ervaringen/toevoegen" className="menu-link">
                    <span className="menu-icon"><i className="fa fa-utensils"></i></span>
                    <span className="menu-text">Ervaringen Toevoegen</span>
                  </Link>
                </div>
              )}
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default ErvaringenMenu;
